module.exports = __webpack_public_path__ + "static/bg.002c6ed3.png";